import { lazy } from 'react';
import { RouteName } from './constants';

const Login = lazy(() => import('src/pages/auth/Login'));
const NotRegistered = lazy(() => import('src/components/NotRegistered'));
const Terms = lazy(() => import('src/components/Terms'));
const HomeScreen = lazy(() => import('src/pages/HomeScreen'));
const HomeScreenV2 = lazy(()=> import('src/pages/HomeScreen/v2/index'));
const Quotes = lazy(() => import('src/pages/Quotes'));
const QuotesV2 = lazy(() => import('src/pages/QuotesV2'));
const QuoteDetails = lazy(() => import('src/pages/QuoteDetails'));
const QuoteDetailsV2 = lazy(() => import('src/pages/QuoteDetails/QuoteDetailsV2'));
const Profile = lazy(() => import('src/pages/Account/Profile'));
const Orders = lazy(() => import('src/pages/Orders'));
const OrdersV2 = lazy(() => import('src/pages/OrdersV2'));
const Payments = lazy(() => import('src/pages/Payments'));
const Search = lazy(() => import('src/pages/Search'));
const IntransitDetails = lazy(() => import('src/pages/IntransitDetails'));
const IntransitDetailsV2 = lazy(() => import('src/pages/IntransitDetailsV2'));
const RaiseIssue = lazy(() => import('src/pages/RaiseIssue'));
const DeliveredDetails = lazy(() => import('src/pages/IntransitDetails'));
const DeliveredDetailsV2 = lazy(() => import('src/pages/IntransitDetailsV2'));
const ProductionDetail = lazy(() => import('src/pages/OrderProductionDetails'));
const ProductionDetailV2 = lazy(() => import('src/pages/OrderProductionDetailsV2'));
const downloadOrder = lazy(() => import('src/pages/downloadOrder'));
const Summary = lazy(() => import('src/pages/Account/Summary'));
const createCustomer = lazy(() => import('src/pages/CreateCustomer'));
const OTP = lazy(() => import('src/pages/auth/OTP'));
const RequestCreate = lazy(() => import('src/pages/RequestCreate'));
const NewQueryV2 = lazy(() => import('src/pages/NewQuery'));
const FeedBack = lazy(() => import('src/pages/FeedBack'));
const FeedBackV2 = lazy(() => import('src/pages/FeedBackV2'));
const CreateQueryV2 = lazy(() => import('src/pages/CreateQuery'));
const TopSelling = lazy(() => import('src/pages/TopSelling'));
const Editspecifications = lazy(() => import('src/pages/EditSpecifications'));
const CreateOrder = lazy(() => import('src/pages/Orders/CreateOrder'));
const CreateOrderV2 = lazy(() => import('src/pages/Orders/CreateOrder/CreateOrderV2'));
const InternationalPayment =lazy(()=>import('src/pages/Orders/CreateOrder/PaymentInternational'))
const CreateOrderConfirmDetails = lazy(
  () => import('src/pages/Orders/CreateOrder/ConfirmOrderDetails'),
);
const CreateOrderConfirmDetailsV2 = lazy(
  () => import('src/pages/Orders/CreateOrder/ConfirmOrderDetailsV2'),
);
const LiveQualitiesDetailsView = lazy(
  () => import('src/pages/LiveQualityDetailsView'),
);
const LiveQualitiesOrderConfirmDetails = lazy(
  () => import('src/pages/Orders/CreateOrder/ConfirmOrderDetails'),
);
const LiveQualitiesOrderConfirmDetailsV2 = lazy(
  () => import('src/pages/Orders/CreateOrder/ConfirmOrderDetailsV2'),
);
const TopSellingCreateOrderConfirmDetails = lazy(
  () => import('src/pages/Orders/CreateOrder/ConfirmOrderDetails'),
);
const TopSellingCreateOrderConfirmDetailsV2 = lazy(
  () => import('src/pages/Orders/CreateOrder/ConfirmOrderDetailsV2'),
);
const CreateOrderPaymentDetails = lazy(() => import('src/pages/Orders/CreateOrder/PaymentTerms'));
const CreateOrderPaymentDetailsV2 = lazy(() => import('src/pages/Orders/CreateOrder/PaymentTermsV2'));
const SamplePaymentPage = lazy(() => import('src/pages/ComparisonView/SamplePaymentPage'));
const AppLink = lazy(() => import('src/pages/AppLink'));

const packingListDownload = lazy(() => import('src/pages/fileDownloader'));

const Credit = lazy(()=> import('src/pages/Credit/index'));

export const routesArray = [
  {
    isProtected: false,
    path: RouteName.login,
    Component: Login,
  },
  {
    isProtected: false,
    path: RouteName.notregistered,
    Component: NotRegistered,
  },
  {
    isProtected: true,
    path: RouteName.homescreen,
    Component: HomeScreen,
  },
  {
    isProtected: true,
    path: RouteName.topSelling,
    Component: TopSelling,
  },
  {
    isProtected: true,
    path: RouteName.quotes,
    Component: Quotes,
  },
  {
    isProtected: false,
    path: RouteName.terms,
    Component: Terms,
  },
  {
    isProtected: true,
    path: RouteName.quotedetails,
    Component: QuoteDetails,
  },
  {
    isProtected: true,
    path: RouteName.profile,
    Component: Profile,
  },
  {
    isProtected: true,
    path: RouteName.payments,
    Component: Payments,
  },
  {
    isProtected: true,
    path: RouteName.search,
    Component: Search,
  },
  {
    isProtected: true,
    path: RouteName.orders,
    Component: Orders,
  },
  {
    isProtected: true,
    path: RouteName.intransitdetails,
    Component: IntransitDetails,
  },
  {
    isProtected: true,
    path: RouteName.raiseIssue,
    Component: RaiseIssue,
  },
  {
    isProtected: true,
    path: RouteName.productiondetails,
    Component: ProductionDetail,
  },
  {
    isProtected: true,
    path: RouteName.account,
    Component: Summary,
  },
  {
    isProtected: false,
    path: RouteName.createCustomer,
    Component: createCustomer,
  },
  {
    isProtected: false,
    path: `${RouteName.otp}/:number`,
    Component: OTP,
  },
  {
    isProtected: true,
    path: RouteName.requestcreate,
    Component: RequestCreate,
  },
  {
    isProtected: true,
    path: RouteName.editspecifications,
    Component: Editspecifications,
  },
  {
    isProtected: true,
    path: RouteName.deliveredDetails,
    Component: DeliveredDetails,
  },
  {
    isProtected: true,
    path: RouteName.feedBack,
    Component: FeedBack,
  },
  {
    isProtected: true,
    path: RouteName.createOrder,
    Component: CreateOrder,
  },
  {
    isProtected: true,
    path: RouteName.CreateOrderConfirmDetails,
    Component: CreateOrderConfirmDetails,
  },
  {
    isProtected: true,
    path: RouteName.LiveQualityConfirmDetails,
    Component: LiveQualitiesDetailsView,
  },
  {
    isProtected: true,
    path: RouteName.liveQualityCreateOrderConfirmDetails,
    Component: LiveQualitiesOrderConfirmDetails,
  },
  {
    isProtected: true,
    path: RouteName.topSellingreateOrderConfirmDetails,
    Component: TopSellingCreateOrderConfirmDetails,
  },
  {
    isProtected: true,
    path: RouteName.CreateOrderPaymentDetails,
    Component: CreateOrderPaymentDetails,
  },
  {
    isProtected: false,
    path: RouteName.appLink,
    Component: AppLink,
  },
  {
    isProtected:false,
    path:RouteName.PaymentInternational,
    Component:InternationalPayment,
  },
  {
    isProtected: false,
    path: RouteName.downloadOrder,
    Component:downloadOrder,
  },
  {
    isProtected: false,
    path: RouteName.packingListDownload,
    Component:packingListDownload,
  },
  {
    isProtected: true,
    path: RouteName.samplePayment,
    Component: SamplePaymentPage,
  },
  {
    isProtected: true,
    path: RouteName.credit,
    Component: Credit,
  },
];

export const webRoutesArray = [
  {
    isProtected: false,
    path: RouteName.login,
    Component: Login,
  },
  {
    isProtected: false,
    path: RouteName.notregistered,
    Component: NotRegistered,
  },
  {
    isProtected: true,
    path: RouteName.homescreen,
    Component: HomeScreenV2,
  },
  {
    isProtected: true,
    path: RouteName.quotes,
    Component: QuotesV2,
  },
  {
    isProtected: false,
    path: RouteName.terms,
    Component: Terms,
  },
  {
    isProtected: true,
    path: RouteName.quotedetails,
    Component: QuoteDetailsV2,
  },
  {
    isProtected: true,
    path: RouteName.payments,
    Component: Payments,
  },
  {
    isProtected: true,
    path: RouteName.orders,
    Component: OrdersV2,
  },
  {
    isProtected: true,
    path: RouteName.intransitdetails,
    Component: IntransitDetailsV2,
  },
  {
    isProtected: true,
    path: RouteName.productiondetails,
    Component: ProductionDetailV2,
  },
  {
    isProtected: true,
    path: RouteName.account,
    Component: Summary,
  },
  {
    isProtected: false,
    path: RouteName.createCustomer,
    Component: createCustomer,
  },
  {
    isProtected: false,
    path: `${RouteName.otp}/:number`,
    Component: OTP,
  },
  {
    isProtected: true,
    path: RouteName.newquery,
    Component: NewQueryV2,
  },
  {
    isProtected: true,
    path: RouteName.createquery,
    Component: CreateQueryV2,
  },
  {
    isProtected: true,
    path: RouteName.deliveredDetails,
    Component: DeliveredDetailsV2,
  },
  {
    isProtected: true,
    path: RouteName.feedBack,
    Component: FeedBackV2,
  },
  {
    isProtected: true,
    path: RouteName.createOrder,
    Component: CreateOrderV2,
  },
  {
    isProtected: true,
    path: RouteName.CreateOrderConfirmDetails,
    Component: CreateOrderConfirmDetailsV2,
  },
  {
    isProtected: true,
    path: RouteName.liveQualityCreateOrderConfirmDetails,
    Component: LiveQualitiesOrderConfirmDetailsV2,
  },
  {
    isProtected: true,
    path: RouteName.topSellingreateOrderConfirmDetails,
    Component: TopSellingCreateOrderConfirmDetailsV2,
  },
  {
    isProtected: true,
    path: RouteName.CreateOrderPaymentDetails,
    Component: CreateOrderPaymentDetailsV2,
  },
  {
    isProtected: false,
    path: RouteName.appLink,
    Component: AppLink,
  },
  {
    isProtected:false,
    path:RouteName.PaymentInternational,
    Component:InternationalPayment,
  },
  {
    isProtected: false,
    path: RouteName.downloadOrder,
    Component:downloadOrder,
  },
  {
    isProtected: false,
    path: RouteName.packingListDownload,
    Component:packingListDownload,
  },
  {
    isProtected: true,
    path: RouteName.samplePayment,
    Component: SamplePaymentPage,
  },
  {
    isProtected: true,
    path: RouteName.credit,
    Component: Credit,
  },
];